module.exports = __webpack_public_path__ + "c015615654.png";